const Characteristics = [
  {
    title: 'basico',
    titles: [
      {
        first: 'Técnico',
        second: 'Básico',
        subtitle: 'gastronomía',
        description: "¿Has pensado en tomar cursos de cocina o convertirte en chef? ¿Te apasionan la comida y las técnicas de cocina? <br/> En Amura Costa Rica, hemos creado el programa profesional en Gastronomía más innovador del país.",
        connector: 'en',
        duration: '2',
        durationTitle: 'cuatrimestres',
      }
    ],
  },
  {
    title: 'medio',
    titles: [
      {
        first: 'Técnico',
        second: 'Medio',
        subtitle: 'gastronomía',
        description: "¿Has pensado en tomar cursos de cocina avanzados o convertirte en un chef profesional? ¿Te apasiona la gastronomía y quieres llevar tus habilidades culinarias al siguiente nivel?  <br/> En Amura Costa Rica, hemos creado el programa de Técnico Medio en Gastronomía más innovador y completo del país.",
        connector: 'en',
        duration: '3',
        durationTitle: 'cuatrimestres',
      }
    ],
  },
  {
    title: 'profesional',
    titles: [
      {
        first: 'Técnico',
        second: 'Profesional',
        subtitle: 'artes culinarias y emprendimiento con énfasis en gastronomía',
        description: 'Si buscás una formación completa que te prepare para los más altos niveles de la industria gastronómica, nuestro Técnico Profesional en Gastronomía es para vos. <span class="font-bold">Aprenderás desde técnicas culinarias avanzadas hasta gestión de negocios gastronómicos y diseño de experiencias culinarias innovadoras.</span>',
        connector: 'en',
        duration: '6',
        durationTitle: 'cuatrimestres',
      }
    ],
  },
  {
    title: 'panaderia-y-pasteleria',
    titles: [
      {
        first: 'Especialidad',
        second: '',
        subtitle: 'Panadería & Pastelería',
        description: '<span class="font-bold">Domina el arte de la panadería y pastelería con una formación creativa y profesional.</span> Aprendé desde lo básico hasta técnicas avanzadas en postres, chocolatería, diseño de queques y más.',
        connector: 'en',
        duration: '8',
        durationTitle: 'módulos independientes',
      }
    ],
  },
  {
    title: 'mixologia',
    titles: [
      {
        first: 'Especialidad',
        second: '',
        subtitle: 'Mixología',
        description: '¡Descubre el arte de ser bartender profesional! Aprende desde la historia de la coctelería hasta el montaje de tu propia barra, combinando teoría, práctica y pasión por la mixología.',
        connector: 'en',
        duration: '2',
        durationTitle: 'cuatrimestres',
      }
    ],
  },
  {
    title: 'barismo',
    titles: [
      {
        first: 'Especialidad',
        second: '',
        subtitle: 'Barismo',
        description: 'Conviértete en un experto del café: explora su origen, domina las técnicas de preparación y crea experiencias únicas en cada taza.',
        connector: 'en',
        duration: '3',
        durationTitle: 'cuatrimestres',
      }
    ],
  }
]

export default Characteristics;